import * as React from 'react';

import { styled, useTheme } from '@mui/material/styles';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import './sidebar.css';

import Box from '@mui/material/Box';

import MuiDrawer from '@mui/material/Drawer';

import MuiAppBar from '@mui/material/AppBar';

import Toolbar from '@mui/material/Toolbar';

import CssBaseline from '@mui/material/CssBaseline';

import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';

import logoutPng from '../../../assets/logos/logoutIcons.png';

import MenuIcon from '@mui/icons-material/Menu';

import { Menu, MenuItem, Modal, Tooltip } from '@mui/material';

import { Outlet, useLocation } from 'react-router';

import { useNavigate } from 'react-router-dom';
import { Feedback, Refresh, Sync } from '@mui/icons-material';
import { logout } from '../../services/api/apiManager';
import FeedbackPopup from '../../main/accounts/feedback/FeedbackPopup';

const drawerWidth = 240;
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 500,
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	p: 4,
	borderRadius: '10px',
};

const openedMixin = (theme) => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
	backgroundColor: '#0E4374',
});

const closedMixin = (theme) => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	backgroundColor: '#0E4374',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

const AppBar = styled(MuiAppBar, {
	shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
	zIndex: theme.zIndex.drawer + 1,
	transition: theme.transitions.create(['width', 'margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	...(open && {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	}),
}));

const Drawer = styled(MuiDrawer, {
	shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
	width: drawerWidth,
	whiteSpace: 'nowrap',
	boxSizing: 'border-box',
	backgroundColor: '#0E4374',
	...(open && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
		backgroundColor: '#0E4374',
	}),
}));
// logout button function is here
export const logoutFunc = async () => {
	const refreshToken = { refresh_token: localStorage.getItem('refreshtoken') };
	localStorage.removeItem('accessToken');
	localStorage.removeItem('user');
	localStorage.removeItem('refreshtoken');
	localStorage.removeItem('loginTime');
	localStorage.removeItem('practice_id');
	localStorage.removeItem('userName');
	localStorage.removeItem('prName');
	localStorage.removeItem('OSW_id');
	localStorage.removeItem('OID');
	const resp = await logout(refreshToken);
	console.log(resp);
};
export default function Navbar() {
	const theme = useTheme();
	const navigate = useNavigate();
	// const [{user,practice},dispatch] = useStateValue();
	const user = localStorage.getItem('userName');
	const practice = localStorage.getItem('prName');
	// console.log("pr:",practice)

	const [openModal, setOpenModal] = React.useState(false);

	const handleEditProvider = (id) => {
		// Here you can perform any necessary actions before opening the modal
		setOpenModal(true);
	};

	const handleCloseEditModal = () => {
		setOpenModal(false);
	};

	// notifications and profile settings togggle functions here
	const settings = ['Profile', 'Logout'];

	const [anchorElUser, setAnchorElUser] = React.useState(null);

	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};

	const [anchorElNotifications, setAnchorElNotifications] =
		React.useState(null);

	const [showNotificationSettings, setShowNotificationSettings] =
		React.useState(false);

	// for checking cuurent location with help of react router dom
	const currentlocation = useLocation();
	const [locationName, setLocationName] = React.useState(
		currentlocation.pathname
	);

	const settingLocationName = () => {
		setLocationName(
			currentlocation.pathname.slice(1).charAt(0).toUpperCase() +
				currentlocation.pathname.slice(2).replace(/_/g, ' ')
		);
	};

	// logout button function is here
	// const logoutFunc = async (refreshToken) => {
	// 	const resp = await logout(refreshToken);
	// 	console.log(resp);
	// };
	React.useEffect(() => {
		settingLocationName();
	});

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />

			<AppBar
				position="fixed"
				// open={open}
				sx={{
					// bgcolor: '#FFFFFF',
					boxShadow: '0px 1px 4px 0px #00000040',
					zIndex: 1,
					paddingLeft: '40px',
					background: 'white',
				}}
				// sx={{ bgcolor: '#FFFFFF', boxShadow: '0px 1px 4px 0px #00000040' ,zIndex:-10}}
			>
				<Toolbar sx={{ boxShadow: 'none' }}>
					<Box width={'100%'} display={'flex'} justifyContent={'flex-end'}>
						<Box
							display={{
								xs: 'flex',
								sm: 'flex',
								md: 'flex',
								lg: 'flex',
								xl: 'flex',
							}}
							gap={1}
						>
							<Box
								style={{
									flexDirection: 'row',
									display: 'flex',
									cursor: 'pointer',
								}}
							>
								<Box
									sx={{ display: 'flex', alignItems: 'center' }}
									onClick={handleOpenUserMenu}
								>
									<Box sx={{ padding: '5px 10px' }}>
										<Typography
											fontSize={'15px'}
											fontWeight="bold"
											fontFamily={'Poppins'}
											color={'#000000'}
										>
											{user}
										</Typography>
										<Typography
											fontSize={'12px'}
											fontFamily={'Poppins'}
											color={'#000000'}
											textAlign={'center'}
										>
											{practice && practice}
										</Typography>
									</Box>
									{/* <Tooltip title="Open Profile Settings">
										<IconButton sx={{ p: 0, mr: 2 }}>
											<img src={userIconPng} alt="usericon" width={'30px'} />
										</IconButton>
									</Tooltip> */}
								</Box>
								<Menu
									sx={{ mt: '45px' }}
									id="menu-appbar"
									anchorEl={anchorElUser}
									anchorOrigin={{
										vertical: 'top',
										horizontal: 'right',
									}}
									keepMounted
									transformOrigin={{
										vertical: 'top',
										horizontal: 'right',
									}}
									open={Boolean(anchorElUser)}
									onClose={handleCloseUserMenu}
								>
									<MenuItem
										sx={{ flexDirection: 'column' }}
										onClick={handleEditProvider}
									>
										<Box
											width={'100%'}
											gap={1}
											display={'flex'}
											justifyContent={'center'}
											alignItems={'center'}
										>
											<Feedback fontSize="10px" />
											<Typography
												width={'60%'}
												textAlign={'start'}
												color={'#404040'}
												fontSize={'12px'}
												fontWeight={400}
											>
												Feedback
											</Typography>
										</Box>
									</MenuItem>
									<Modal
										open={openModal}
										onClose={handleCloseEditModal}
										aria-labelledby="edit-modal-title"
										aria-describedby="edit-modal-description"
										sx={{
											'& .MuiModal-backdrop': {
												opacity: '30 !important',
											},
										}}
									>
										<Box sx={{ style }}>
											<FeedbackPopup onClose={handleCloseEditModal} />
										</Box>
									</Modal>

									<MenuItem
										sx={{ flexDirection: 'column' }}
										onClick={() => {
											logoutFunc();
											navigate('/');
										}}
									>
										<Box
											width={'100%'}
											gap={1}
											display={'flex'}
											justifyContent={'center'}
											alignItems={'center'}
										>
											<Box width={'15%'}>
												<img src={logoutPng} alt="logout icon" width={'10px'} />
											</Box>
											<Typography
												width={'60%'}
												textAlign={'start'}
												color={'#404040'}
												fontSize={'12px'}
												fontWeight={400}
											>
												Logout
											</Typography>
										</Box>
									</MenuItem>
								</Menu>
							</Box>
						</Box>
						{/* Menu Icon for XS and SM screens */}
						<Box
							display={{
								xs: 'flex',
								sm: 'flex',
								md: 'none',
								lg: 'none',
								xl: 'none',
							}}
						>
							<IconButton
								onClick={handleOpenUserMenu}
								sx={{ p: 0, ml: 'auto' }}
							>
								{/* Your Menu Icon  */}
								<MenuIcon />
							</IconButton>
						</Box>
					</Box>
				</Toolbar>
			</AppBar>

			<Box
				component="main"
				sx={{ paddingTop: '50px', height: '100%' }}
				// onMouseEnter={closeSidebar}
			>
				<AppBar />
				<Outlet />
			</Box>
		</Box>
	);
}
